/**
 * Created by emanuele on 23/05/2017.
 */
import React, {Component} from 'react';
import PrintButton from '../PrintButton'
import ReportMovimentiViewSwitcher from '../report/ReportMovimentiViewSwitcher'
import PdfButton from '../PdfButton'
import Movimenti from '../../pdf/Movimenti';
import MovimentiTotali from '../../pdf/MovimentiTotali';
import {Checkbox} from "semantic-ui-react";

class MovimentiReportList extends Component {

    constructor(props) {
        super(props);
        this.state = {viewData: false};
        this.pdfExport = this.pdfExport.bind(this);
        this.onDataCompleted = this.onDataCompleted.bind(this);
        this.onViewDataChange = this.onViewDataChange.bind(this)
        this.onExportPerBudgetClick = this.onExportPerBudgetClick.bind(this)
    }

    pdfExport(){
        let ce = new Movimenti();
        ce.setTitle("Report Movimenti");
        ce.setFileName("report-movimenti.pdf");
        ce.setFilterDescription(this.props.filterDescription);
        //console.log("DATA:", this.data);
        ce.createPdf(this.data);
    }

    pdfExportTotali(){
        let ce = new MovimentiTotali();
        ce.setTitle("Report Riassuntivo Movimenti");
        ce.setFileName("report-riassuntivo-movimenti.pdf");
        ce.setFilterDescription(this.props.filterDescription);
        ce.createPdf(this.data);
    }

    onDataCompleted(data){
        this.data = data;
    }

    onViewDataChange(a1, {name, checked}){
        this.setState({viewData: checked})
    }

    onExportPerBudgetClick(format){
        
        if (this.props.onExportPerBudget !== undefined){
            this.props.onExportPerBudget(format)
        }
    }

    render(){
        return (
            <div className="ui segments">
                <div className="ui secondary segment no-print">
                    <div className="ui two column stackable grid ">
                        <div className="row">
                            <div className="column">
                                {/*<PrintButton />*/}
                                <PdfButton title="PDF Completo" onClick={(ev) => (this.pdfExport())} />
                                <PdfButton title="PDF per Budget" onClick={(ev) => (this.pdfExportTotali())} />
                                <a href="#" onClick={(ev) => (this.onExportPerBudgetClick('xlsx'))}>
                                    <div className="ui left floated small primary labeled icon button">
                                        <i className="file excel outline icon"></i> Excel per Budget
                                    </div>
                                </a>

                            </div>
                            <div className="column">
                                <Checkbox label="Mostra Dati" name="isDatiVisualizzati" toggle checked={this.state.viewData} onChange={this.onViewDataChange} />
                            </div>
                        </div>
                    </div>
                </div>
                <div id="printme" className="ui segment">
                    <ReportMovimentiViewSwitcher {...this.props} onDataCompleted={this.onDataCompleted} viewData={this.state.viewData}/>
                </div>
            </div>
        )
    }
}

export default MovimentiReportList;


/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentiReportList.js
 **/